import React from "react";
import { contactName } from '../../helpers/ContactName';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {
  apiCall, getBranches, getCustomers
} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import CollectionsTable from "../../components/Tables/CollectionsTable";
import { openCollectionAddModel, closeCollectionAddModel } from "../../actions";
import AddCollectionModal from "../../components/AddCollectionModal";
class ReceivableDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collections: [],
      customers: [],
      branches: [],
      isLoad: true,
      loading: false,
      formData: {
        id: '',
        customer_id: '',
        branch_id: '',
        description: '',
        amount: '',
        due_date: '',
        status: '',
        invoice_id: '',
        invoice_no: '',
        b_a: '',
        invoice_file: '',
        invoice_file_show: '',
      }
    }
  }
  async componentDidMount() {
    try {
      await this.getReceivableInfo();
      this.setState({
        branches: await getBranches(),
        customers: await getCustomers()
      });
    } catch (e) {
      throw e;
    }
  }
  getReceivableInfo = async () => {
    const id = this.props.match.params.id;
    try {
      const response = await apiCall('business/receivable/info/' + id, 'get', null);
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        if (key === "invoice_file_show") {
          updatedData['invoice_file_show'] = response['invoice_file'] === undefined || response['invoice_file'] === null ? "" : response['invoice_file'];
        } else {
          updatedData[key] = response[key] === undefined || response[key] === null ? "" : response[key];
        }
      });

      this.setState({
        formData: updatedData,
        collections: response.collections,
        isLoad: false
      });
    } catch (e) {
      console.error(e);
    }
  }
  handleChange = (e) => {
    const { id, value } = e.target;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [id]: value
      }
    }));
  }
  handleInvoiceChange = (e) => {
    const { files } = e.target;

    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        invoice_file: files[0]
      },
    }));
  }
  showAddCollectionModel = () => {
    this.props.openCollectionAddModel(this.state.formData.id);
  }
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { formData } = this.state;
    const receiveFormData = new FormData();
    Object.keys(formData).forEach(key => {
      receiveFormData.append(key, formData[key]);
    });

    try {
      const response = await apiCall('business/receivable/update/' + formData.id, 'post', receiveFormData);
      this.setState({ loading: false, invoice_file_show: true });
      mainHelper.toastMessage(response.status, response.message)
    } catch (e) {
      this.setState({ loading: false });
    }

  }
  handleShowUploadedInvoice = () => {
    var link = `${process.env.REACT_APP_MAIN_URL}/invoice/receivable/uploaded/${this.state.formData.id}`;
    window.open(link, '_blank');
  };
  render() {
    const { formData, branches, customers, loading, isLoad, collections } = this.state;
    const { userPermissions } = this.props;
    const userHasUpdateReceivablePermission = userPermissions.includes('update receivable');
    const userHasNewtahsilatPermission = userPermissions.includes('new receivable receivable');
    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{ display: this.state.isLoad ? 'block' : 'none' }}>
            <div className="loader" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid" />
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
              HeaderText="Müşteri Cari Detayları"
              Breadcrumb={[
                { name: "Müşteri Cari Hareketleri", navigate: "receivables" },
                { name: "Müşteri Cari Detayları", navigate: "" },
              ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">

                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <h6>Cari Detayı</h6>
                      {this.state.formData.invoice_file_show && (
                        <div className="row">
                          <div className="col-lg-12 d-flex justify-content-end">
                            <div className="col-lg-3">
                              <button onClick={this.handleDeleteUploadedInvoice} title="Faturayı Sil"
                                type="button" className="btn btn-outline-danger float-right ml-2"><i
                                  className="fa fa-trash"></i>
                              </button>
                              <button onClick={this.handleShowUploadedInvoice} title="Fatura Görüntüle"
                                type="button" className="btn btn-outline-info float-right"><i
                                  className="fa fa-file-text-o"></i>
                              </button>
                            </div>

                          </div>

                        </div>
                      )}
                      <div className="row clearfix">
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="customer_id"
                              className="font-weight-bold text-cyan">
                              Müşteri/Tedarikçi
                            </label>
                            <select id='customer_id'
                              className="form-control"
                              value={formData.customer_id}
                              disabled={true}
                              onChange={this.handleChange}>
                              <option value="">Müşteri/Tedarikçi Seçiniz</option>
                              {customers && (customers.map(customer => (
                                <option key={customer.id}
                                  value={customer.id}>{contactName(customer)}</option>
                              )))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="branch_id"
                              className="font-weight-bold text-cyan">
                              Şube
                            </label>
                            <select id='branch_id'
                              className="form-control"
                              value={formData.branch_id}
                              onChange={this.handleChange}>
                              <option value="">Şube Seçiniz</option>
                              {branches && (branches.map(branch => (
                                <option key={branch.id}
                                  value={branch.id}>{branch.name}</option>
                              )))}
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="due_date"
                              className="font-weight-bold text-cyan">
                              Tip
                            </label>
                            <select id='b_a'
                              className="form-control"
                              value={formData.b_a}
                              onChange={this.handleChange}>
                              <option value="">Tip Seçiniz</option>
                              <option value="alacak">Alacak</option>
                              <option value="borc">Borç</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="status"
                              className="font-weight-bold text-cyan">
                              Durum
                            </label>
                            <select id='status'
                              className="form-control"
                              value={formData.status}
                              onChange={this.handleChange}>
                              <option value="">Durum Seçiniz</option>
                              <option value="Ödendi">Ödendi</option>
                              <option value="Ödenmedi">Ödenmedi</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="due_date"
                              className="font-weight-bold text-cyan">
                              Son Ödeme Tarihi
                            </label>
                            <input
                              id="due_date"
                              type="date"
                              className="form-control"
                              value={formData.due_date}
                              onChange={this.handleChange} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="description"
                              className="font-weight-bold text-cyan">
                              Detay
                            </label>
                            <textarea
                              id="description"
                              className="form-control"
                              placeholder="Açıklama"
                              value={formData.description}
                              onChange={this.handleChange}>
                            </textarea>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="amount"
                              className="font-weight-bold text-cyan">
                              Tutar
                            </label>
                            <input
                              id="amount"
                              type="number"
                              step="0.1"
                              className="form-control"
                              placeholder="Tutar giriniz"
                              value={formData.amount}
                              onChange={this.handleChange} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="invoice_no" className="font-weight-bold text-cyan">
                              Fatura No
                            </label>
                            <input
                              id="invoice_no"
                              type="text"
                              placeholder="Fatura No"
                              className="form-control"
                              value={formData.invoice_no}
                              onChange={this.handleChange} />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                          <div className="form-group">
                            <label htmlFor="invoice_file" className="font-weight-bold text-cyan">
                              Fatura Yükle
                            </label>
                            <input name="operationData.invoice_file"
                              id="invoice_file"
                              className="form-control"
                              type="file"
                              accept="application/pdf|image/*"
                              onChange={this.handleInvoiceChange}
                            />
                          </div>
                        </div>
                      </div>

                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          {loading ? (
                            <button className="btn btn-outline-primary btn-block"
                              disabled={true}
                              style={{ textAlign: "-webkit-center" }}>
                              Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'}
                                height={'24px'}
                                color="#268bd2"></ReactLoading>
                            </button>
                          ) :
                            <button disabled={!userHasUpdateReceivablePermission}
                              className="btn btn-outline-primary btn-block"
                              type="submit">
                              Güncelle
                            </button>}

                        </div>
                      </div>
                    </div>
                  </form>
                  <div className="col-lg-12">
                    <div className="body">
                      <button disabled={!userHasNewtahsilatPermission} onClick={() => this.showAddCollectionModel()} type="button"
                        className="btn btn-outline-primary float-right"><i className="icon-plus"></i>
                        {formData.b_a === "alacak" ? " Yeni Tahsilat" : " Yeni Ödeme"}
                      </button>
                      <div className="card">
                        <div className="header">

                          <h2>{formData.b_a === "alacak" ? "Tahsilatlar" : "Ödemeler"}</h2>
                          <small>{`${formData.b_a === "alacak" ? "Tahsilat" : "Ödeme"} ekleme ekranı ile yapılan ödemeleri hızlı ve kolay bir şekilde kaydedebilir, düzenli olarak takip edebilirsiniz. Bu sayede, işletmenizin nakit akışını etkin bir şekilde yönetebilir ve finansal durumunuzu güncel tutabilirsiniz.`}</small>
                        </div>
                        {!isLoad && (
                          <>
                            {collections && Object.keys(collections).length > 0 ? (
                              <CollectionsTable bodyData={collections} fetchReceive={this.getReceivableInfo} />
                            ) : (
                              <div className="alert alert-warning text-center">
                                {collections ? "Veri yok" : "Tabloda Veri yok"}
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <AddCollectionModal fetchReceive={this.getReceivableInfo}></AddCollectionModal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ ioTReducer, mailInboxReducer }) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
  isAddTaskModalOpen: mailInboxReducer.isAddTaskModalOpen,
  addTaskModalData: mailInboxReducer.addTaskModalData,
});

export default withPermissions(withRouter(connect(mapStateToProps, { openCollectionAddModel, closeCollectionAddModel })(ReceivableDetail)));
